import '../../styles/button/group-button.css'

const GroupButton = ({children,action,disabled,direction}) => {
  return (
    <button onClick={action} className={`group-button ${direction === 'left' ? 'group-button--direction-left' : 'group-button--direction-right'}`} disabled={disabled}>{children}</button>
  )
}

export default GroupButton